import { CALL_API } from "../api.middleware";
export const getEaadhaar = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/subscriberJourney/distributor/getAadhaarDetails",
          body: { ...body },
          method: "POST",
          isNpsSubscriber: true,
        },
      });
    } catch (error) {
      alert(error);
      console.error(error);
    }
  };
};
